import {
    LIST_ORGANIZATIONS, LIST_ORGANIZATIONS_SUCCESS, LIST_ORGANIZATIONS_FAILURE,
    CREATE_ORGANIZATION, CREATE_ORGANIZATION_SUCCESS, CREATE_ORGANIZATION_FAILURE,
    UPDATE_ORGANIZATION, UPDATE_ORGANIZATION_FAILURE, UPDATE_ORGANIZATION_SUCCESS,
    DELETE_ORGANIZATION, DELETE_ORGANIZATION_SUCCESS, DELETE_ORGANIZATION_FAILURE,
    OPEN_DELETE_DIALOG,
    OPEN_CREATE_DIALOG,
    OPEN_UPDATE_DIALOG,
    CLOSE_DIALOGS,
} from './OrganizationsActionTypes';

export const createOrganization = (organizationName, contactName, contactPhone) => ({
    type: CREATE_ORGANIZATION,
    organizationName,
    contactName,
    contactPhone
})
export const createOrganizationSucceeded = () => ({
    type: CREATE_ORGANIZATION_SUCCESS,
})
export const createOrganizationFailed = (response) => ({
    type: CREATE_ORGANIZATION_FAILURE,
    response
})

export const updateOrganization = (organizationId, organizationName, contactName, contactPhone) => ({
    type: UPDATE_ORGANIZATION,
    organizationId,
    organizationName,
    contactName,
    contactPhone
})
export const updateOrganizationSucceeded = () => ({
    type: UPDATE_ORGANIZATION_SUCCESS,
})
export const updateOrganizationFailed = (response) => ({
    type: UPDATE_ORGANIZATION_FAILURE,
    response
})

export const deleteOrganization = (organizationId) => ({
    type: DELETE_ORGANIZATION,
    organizationId
})
export const deleteOrganizationSucceeded = () => ({
    type: DELETE_ORGANIZATION_SUCCESS,
})
export const deleteOrganizationFailed = (response) => ({
    type: DELETE_ORGANIZATION_FAILURE,
    response
})

export const listOrganizations = () => ({
    type: LIST_ORGANIZATIONS,
})
export const listOrganizationsSucceeded = (organizations) => ({
    type: LIST_ORGANIZATIONS_SUCCESS,
    organizations
})
export const listOrganizationsFailed = (response) => ({
    type: LIST_ORGANIZATIONS_FAILURE,
    response
})

export const openDeleteDialog = (organizationId, organizationName) => ({
    type: OPEN_DELETE_DIALOG,
    organizationId,
    organizationName
})

export const openCreateDialog = () => ({
    type: OPEN_CREATE_DIALOG,
})

export const openUpdateDialog = (organizationId, organizationName, contactName, contactPhone) => ({
    type: OPEN_UPDATE_DIALOG,
    organizationId,
    organizationName,
    contactName,
    contactPhone
})

export const closeDialogs = () => ({
    type: CLOSE_DIALOGS,
})